import Image from 'next/image'

import CocGemIcon from '@/assets/images/icons/coc_icon_gem.png'

import styles from './ProductCategory.module.scss'

interface ProductCategoryHeaderProps {
  title: string
}

export const ProductCategoryHeader = ({ title }: ProductCategoryHeaderProps) => {
  return (
    <div className={styles.Header}>
      <div className={styles.Icon}>
        <Image src={CocGemIcon} alt="gem" fill sizes="50px" />
      </div>
      <h2 className={styles.HeadingText}>{title}</h2>
    </div>
  )
}
